export default "/assets/profile-purple.svg";